import RecommendedArticlesContainer from './RecommendedArticlesContainer';

export default RecommendedArticlesContainer;
